import React, {useState, useRef, useEffect} from "react";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Toast} from "primereact/toast";
import {Button} from "primereact/button";
import Spinner from "../../spinner/Spinner";
import {Chart} from "primereact/chart";
import {Divider} from "primereact/divider";


const Sources = props => {
    const toast = useRef(null);
    // const [server, setServer] = useState(null);
    const [CPU, setCPU] = useState(null);
    const [GPU, setGPU] = useState(null);
    const [ram, setRam] = useState(null);
    const [disk, setDisk] = useState(null);
    const [volume, setVolume] = useState(null);
    // const [volumeGB, setVolumeGB] = useState(null);
    // const [snapshot, setSnapshot] = useState(null);
    const [loadingState, setLoadingState] = useState(false);
    const source_list_role = localStorage.getItem("cloud_source_list") ? true : false;

    const backgroundColor = [
        "#6c757d",
        "#2069E1"
    ];
    const hoverBackgroundColor = [
        "#6c7576",
        "#2776E8"
    ]

    const lightOptions = {
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        }
    };

    useEffect(() => {
        getSources();
    }, []);

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const unitConvert = (start_type, number, float_size = 0) => {
        const units = {
            0: "byte",
            1: "KB",
            2: "MB",
            3: "GB",
            4: "TB",
            5: "PB",
            6: "EB",
            7: "ZB",
            8: "YB"
        }
        let type_size = 0;
        for (let i = 0; i < 9; i++) {
            if (units[i] === start_type) {
                type_size = i;
                break;
            }
        }
        while (number > 1024) {
            type_size++;
            number /= 1024;
        }
        while (number < 0) {
            type_size--;
            number *= 1024;
        }

        if (float_size > 0) {
            number = parseFloat(number).toFixed(float_size);
        }

        return number + " " + units[type_size];
    }

    const getSources = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/cloud-source/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        ////console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            const compute_limit = data.sources.compute;
                            // const volume_limit = data.sources.volume;

                            // setServer(compute_limit['server']);
                            setCPU(compute_limit['cpu']);
                            setRam(compute_limit['ram']);
                            setDisk(compute_limit['disk'])
                            setVolume(compute_limit['volume'])
                            if (compute_limit['gpu']) {
                                setGPU(compute_limit['gpu']);
                            }

                            /*setVolume(volume_limit['volume']);
                            setVolumeGB(volume_limit['volume_gb']);
                            setSnapshot(volume_limit['snapshot']);
*/
                            showSuccess("Kaynaklar Listelendi.");
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const getChartTemplate = (chartData, headers, data_obj, type) => {
        return (
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                <div className="card p-d-flex p-jc-center">
                    <div className="p-grid" style={{width: "100%"}}>
                        <div className="p-col-12">
                            <Chart type="pie" data={chartData} options={lightOptions}/>
                        </div>
                        <div className="p-col-12" style={{width: '100%', wordBreak: "break-all"}} align="center">
                            <div className="p-grid">
                                <div className="p-col-9">
                                    <strong>{headers[0]}</strong>
                                </div>
                                <div className="p-col-3">
                                    {data_obj !== null
                                        ?
                                        data_obj["data"][0] + data_obj["data"][1]
                                        :
                                        0
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="p-col-12" style={{width: '100%'}} align="center">
                            <div className="p-grid">
                                <div className="p-col-9">
                                    <strong>{headers[1]}</strong>
                                </div>
                                <div className="p-col-3">
                                    {data_obj !== null
                                        ?
                                        data_obj["data"][1]
                                        :
                                        0
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="p-col-12" style={{width: '100%'}} align="center">
                            <div className="p-grid">
                                <div className="p-col-9">
                                    <strong>{headers[2]}</strong>
                                </div>
                                <div className="p-col-3">
                                    {data_obj !== null
                                        ?
                                        data_obj["data"][0]
                                        :
                                        0
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const getUnitChartTemplate = (chartData, headers, data_obj, type) => {
        return (
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                <div className="card p-d-flex p-jc-center">
                    <div className="p-grid" style={{width: "100%"}}>
                        <div className="p-col-12">
                            <Chart type="pie" data={chartData} options={lightOptions}/>
                        </div>
                        <div className="p-col-12" style={{width: '100%', wordBreak: "break-all"}} align="center">
                            <div className="p-grid">
                                <div className="p-col-9">
                                    <strong>{headers[0]}</strong>
                                </div>
                                <div className="p-col-3">
                                    {data_obj !== null
                                        ?
                                        unitConvert(data_obj["type"], data_obj["data"][0] + data_obj["data"][1], 1)
                                        :
                                        0
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="p-col-12" style={{width: '100%'}} align="center">
                            <div className="p-grid">
                                <div className="p-col-9">
                                    <strong>{headers[1]}</strong>
                                </div>
                                <div className="p-col-3">
                                    {data_obj !== null
                                        ?
                                        unitConvert(data_obj["type"], data_obj["data"][1], 1)
                                        :
                                        0
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="p-col-12" style={{width: '100%'}} align="center">
                            <div className="p-grid">
                                <div className="p-col-9">
                                    <strong>{headers[2]}</strong>
                                </div>
                                <div className="p-col-3">
                                    {data_obj !== null
                                        ?
                                        unitConvert(data_obj["type"], data_obj["data"][0], 1)
                                        :
                                        0
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const getChartData = (data_obj) => {
        return {
            labels: data_obj ? data_obj["name"] : [],
            datasets: [
                {
                    data: data_obj ? data_obj["data"] : [],
                    backgroundColor,
                    hoverBackgroundColor
                }
            ]
        };
    }

    if (source_list_role) {
        return (
            <div className='p-fluid'>
                <Toast ref={toast}/>
                <Spinner loadingState={loadingState}/>
                <div className="p-grid" align="center">
                    <div className="p-col-12" align="center"><h3><strong>Hesaplama Kaynakları</strong></h3></div>
                    {getChartTemplate(
                        getChartData(CPU),
                        [
                            "Toplam CPU Sayısı",
                            "Kullanılan CPU Sayısı",
                            "Kalan CPU Sayısı"
                        ],
                        CPU,
                        "compute"
                    )}
                    {getChartTemplate(
                        getChartData(GPU),
                        [
                            "Toplam GPU Sayısı",
                            "Kullanılan GPU Sayısı",
                            "Kalan GPU Sayısı"
                        ],
                        GPU,
                        "compute"
                    )}
                    {getUnitChartTemplate(
                        getChartData(ram),
                        [
                            "Toplam RAM Boyutu",
                            "Kullanılan RAM Boyutu",
                            "Kalan RAM BOYUTU"
                        ],
                        ram,
                        "compute"
                    )}
                    {getUnitChartTemplate(
                        getChartData(volume),
                        [
                            "Toplam Volume Disk Boyutu",
                            "Kullanılan Volume Disk Boyutu",
                            "Kalan Volume Disk Boyutu"
                        ],
                        volume,
                        "compute"
                    )}
                    {getUnitChartTemplate(
                        getChartData(disk),
                        [
                            "Toplam Disk Boyutu",
                            "Kullanılan Disk Boyutu",
                            "Kalan Disk Boyutu"
                        ],
                        disk,
                        "compute"
                    )}
                </div>
                {/*<Divider layout="horizontal"/>
            <div className="p-grid" style={{marginTop: '25px'}}>
                <div className="p-col-12" align="center"><h3><strong>Mantıksal Sürücü</strong></h3></div>
                {getChartTemplate(
                    getChartData(volume),
                    [
                        "Toplam Mantıksal Sürücü Sayısı",
                        "Kullanılan Mantıksal Sürücü Sayısı",
                        "Kalan Mantıksal Sürücü Sayısı"
                    ],
                    volume,
                    "volume"
                )}
                {getUnitChartTemplate(
                    getChartData(volumeGB),
                    [
                        "Toplam Mantıksal Sürücü Depolama Alanı",
                        "Kullanılan Mantıksal Sürücü Depolama Alanı",
                        "Kalan Mantıksal Sürücü Depolama Alanı"
                    ],
                    volumeGB,
                    "volume"
                )}
                {getChartTemplate(
                    getChartData(snapshot),
                    [
                        "Toplam Mantıksal Sürücü Anlık Görüntü Sayısı",
                        "Kullanılan Mantıksal Sürücü Anlık Görüntü Sayısı",
                        "Kalan Mantıksal Sürücü Anlık Görüntü Sayısı"
                    ],
                    snapshot,
                    "volume"
                )}
            </div>*/}
            </div>
        );
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }


}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Sources);


// WEBPACK FOOTER //
// ./src/pages/cloudmanagement/Sources.jsx